interface InternalLinkProps {
  text: string;
  href: string;
  backgroundColor?: string;
  textColor?: string;

  target?: string;
}

export const InternalLink: React.FC<InternalLinkProps> = ({
  text,
  href,
  backgroundColor = 'bg-dark-blue',
  textColor = 'text-white',
  target = '_self',
}) => {
  return (
    <a
      href={href}
      className={`mt-8 mb-4 font-semibold no-underline inline-block ${backgroundColor} ${textColor} py-6 px-8`}
      target={target}
    >
      {text}
    </a>
  );
};
